import { useSearchParams } from 'next/navigation';

export default function useIsDebug() {
	const searchParams = useSearchParams();
	return !!searchParams.get('debug');
}
